import { Outlet } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import LeftNav from '../left-nav';
import Header from '../header';
import Breadcrumbs from "../breadcrumbs";
import { useLocation } from "react-router-dom";
import { selectActiveFeatures, selectPortalUser } from "../../reducers/auth-slice";
import AccessDeniedMessageModal from "../modals/access-denied-message";
import { useMsal } from '@azure/msal-react';

/// Need to show pop up on status' other than Active and Disabled

const DashboardLayout = () => {
    const location = useLocation();
    const portalUser = useSelector(selectPortalUser);
    const activeFeatures = useSelector(selectActiveFeatures);
    const showBreadcrumbs = (location.pathname !== '/orders' && location.pathname !== '/admin' && location.pathname !== '/portal') ? true : false;
    const [accessDenied, setAccessDenied] = useState(false)
    const { instance } = useMsal();
    const invalidFirmStatus = ['Suspended', 'Cut Off']

    useEffect(() => {
        setAccessDenied(portalUser.status === "rejected" || (portalUser.organization && invalidFirmStatus.indexOf(portalUser.organization.status) > -1))
    }, [portalUser, activeFeatures]);

    const handleHideModal = () => {
        let activeAccount = instance.getActiveAccount();
        if (activeAccount) {
            instance.logout(activeAccount)
        }
    }

    return (
        <div className='layout'>
            <LeftNav />

            <div className='layout-content'>
                <Header showUserName={true} />

                {showBreadcrumbs && <Breadcrumbs />}

                <div className={`layout-content-outlet ${!showBreadcrumbs ? 'noBreadcrumbs' : ''}`}>
                    <AccessDeniedMessageModal showModal={accessDenied} handleHideModal={handleHideModal} message={"Please contact Glucroft Investigations Office at 866-411-8646 regarding your account.  Thank you."} />
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;